import * as React from 'react';
import { jsx, Fragment } from 'react/jsx-runtime';

// src/session/SessionProvider.tsx
var SessionReactContext = React.createContext(null);
function SessionProvider({ manager, children }) {
  const [state, setState] = React.useState({ status: "unknown", session: null });
  React.useEffect(() => {
    let active = true;
    manager.bootstrap().then((next) => {
      if (active) setState(next);
    }).catch((error) => {
      if (active) setState({ status: "error", session: null, error });
    });
    return () => {
      active = false;
    };
  }, [manager]);
  const refresh = React.useCallback(async () => {
    const session = await manager.loadSession();
    setState(session ? { status: "authenticated", session } : { status: "unauthenticated", session: null });
  }, [manager]);
  const value = React.useMemo(
    () => ({
      state,
      manager,
      session: state.session,
      isAuthenticated: state.status === "authenticated",
      isLoading: state.status === "unknown",
      login: (options) => manager.login(options),
      logout: (options) => manager.logout(options),
      getAccessToken: () => manager.getAccessToken(),
      refresh
    }),
    [state, manager, refresh]
  );
  return /* @__PURE__ */ jsx(SessionReactContext.Provider, { value, children });
}
function useSession() {
  const ctx = React.useContext(SessionReactContext);
  if (!ctx) throw new Error("useSession must be used inside <SessionProvider>");
  return ctx;
}
function useOptionalSession() {
  return React.useContext(SessionReactContext);
}
function RequireSession({
  children,
  loading = null,
  blocked = null,
  error,
  returnTo,
  loginParams
}) {
  const { state, manager } = useSession();
  const [guard, setGuard] = React.useState("idle");
  const loginParamsKey = loginParams ? JSON.stringify(loginParams) : "";
  React.useEffect(() => {
    if (state.status !== "unauthenticated") return;
    let active = true;
    void manager.requireSession({ returnTo, params: loginParams }).then((result) => {
      if (active && result.outcome === "blocked") setGuard("blocked");
    });
    return () => {
      active = false;
    };
  }, [state.status, manager, returnTo, loginParamsKey]);
  if (state.status === "authenticated") return /* @__PURE__ */ jsx(Fragment, { children });
  if (guard === "blocked" || state.status === "error") return /* @__PURE__ */ jsx(Fragment, { children: error ?? blocked });
  return /* @__PURE__ */ jsx(Fragment, { children: loading });
}

export { RequireSession, SessionProvider, useOptionalSession, useSession };
//# sourceMappingURL=chunk-TX775Q2M.js.map
//# sourceMappingURL=chunk-TX775Q2M.js.map